module.exports = __webpack_public_path__ + "static/video-poster-1d3b33750e75013425b18ad1f8877847.png";